<template>
  <div class="cart-container" v-if="canBeAddedToBasket">
    <div class="checkout-buttons" v-if="showBuyButton">
      <button
        class="btn"
        @click.prevent="addToBasket(true)"
        :disabled="isLoading && !canBeAddedToBasket"
      >
        {{ multiLanguage.ProductBuyNow }}
      </button>
    </div>
    <div class="add-to-basket-container">
      <button
        v-if="!allVariationsSelected || !isSalable"
        class="btn btn-block btn-primary btn-appearance disabled"
        v-tooltip
        data-toggle="tooltip"
        data-placement="top"
        :title="tooltipText"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_727_10530)">
            <path
              d="M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_727_10530">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>

        {{ $translate("Ceres::Template.singleItemAddToBasket") }}
      </button>
      <button
        v-else-if="!buttonLockState"
        :disabled="isLoading || !hasPrice"
        class="btn btn-block btn-primary btn-appearance"
        @click.prevent="addToBasket()"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_727_10530)">
            <path
              d="M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_727_10530">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>

        {{ $translate("Ceres::Template.singleItemAddToBasket") }}
      </button>
      <button
        v-else
        class="btn btn-block btn-primary btn-appearance disabled"
        v-tooltip
        data-toggle="tooltip"
        data-placement="top"
        :title="
          'Ceres::Template.singleItemQuantityMax'
            | translate({ max: maximumQuantity })
        "
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_727_10530)">
            <path
              d="M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_727_10530">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>

        {{ $translate("Ceres::Template.singleItemAddToBasket") }}
      </button>
    </div>
  </div>
</template>

<script>
import ExceptionMap from "../../exceptions/ExceptionMap";
import { navigateTo } from "../../services/UrlService";
import { isNullOrUndefined, isDefined } from "../../helper/utils";
import { mapState } from "vuex";

const NotificationService = require("../../services/NotificationService");

export default {
  name: "add-to-basket",
  props: {
    itemUrl: String,
    showBuyButton: {
      type: Boolean,
      default: false,
    },
    showQuantity: {
      type: Boolean,
      default: false,
    },
    useLargeScale: {
      type: Boolean,
      default: false,
    },
    variationId: {
      type: Number,
    },
    isSalable: {
      type: Boolean,
      default: false,
    },
    hasChildren: {
      type: Boolean,
      default: false,
    },
    intervalQuantity: {
      type: Number,
      default: 1,
    },
    minimumQuantity: {
      type: Number,
      default: 0,
    },
    maximumQuantity: {
      type: Number,
      default: null,
    },
    orderProperties: {
      type: Array,
      default: () => [],
    },
    hasOrderProperties: {
      type: Boolean,
      default: false,
    },
    hasRequiredOrderProperty: {
      type: Boolean,
      default: false,
    },
    hasPrice: {
      type: Boolean,
      default: true,
    },
    hasGraduatedPrice: {
      type: Boolean,
      default: false,
    },
    propQuantity: {
      type: Number,
      default: null,
    },
    itemType: {
      type: String,
      default: null,
    },
    multiLanguage: Object,
  },

  inject: {
    itemId: {
      default: null,
    },
  },

  computed: {
    currentVariation() {
      return this.$store.getters[`${this.itemId}/currentItemVariation`] || null;
    },

    isSet() {
      return (
        (this.$store.state.items[this.itemId] &&
          this.$store.state.items[this.itemId].variation &&
          this.$store.state.items[this.itemId].variation.documents[0].data.item
            .itemType === "set") ||
        this.itemType === "set"
      );
    },

    canBeAddedToBasket() {
      return (
        this.isSalable &&
        !this.hasChildren &&
        !(this.minimumQuantity != 1 || this.intervalQuantity != 1) &&
        !this.requiresProperties &&
        this.hasPrice &&
        !this.hasGraduatedPrice &&
        !this.isSet
      );
    },

    requiresProperties() {
      return (
        (App.config.item.requireOrderProperties &&
          (this.hasOrderProperties ||
            this.orderProperties.filter(
              (property) => property.property.isShownOnItemPage
            ).length > 0)) ||
        this.hasRequiredOrderProperty
      );
    },

    tooltipText() {
      if (this.hasAvailableVariations) {
        return this.$translate(
          "Ceres::Template.singleItemPleaseSelectValidVariation"
        );
      } else {
        return this.$translate(
          "Ceres::Template.singleItemPleaseSelectNotAvailable"
        );
      }
    },

    variationOrderQuantity() {
      return (
        this.$store.state.items[this.itemId] &&
        this.$store.state.items[this.itemId].variationOrderQuantity
      );
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    hasAvailableVariations() {
      return (
        this.$store.state.items[this.itemId] &&
        this.$store.state.items[this.itemId].variationSelect &&
        this.$store.state.items[this.itemId].variationSelect.variations.some(
          (variation) => variation.isSalable
        )
      );
    },

    allVariationsSelected() {
      if (this.isSet) {
        return this.$store.getters["itemSetAllVariationSelected"];
      } else {
        // FIX return true if module is not registered. This equals the default value from the module
        // and is required to use this component in other contexts, e.g. the category view
        return (
          !this.$store.state.items[this.itemId] ||
          (this.$store.state.items[this.itemId].variationSelect &&
            this.$store.state.items[this.itemId].variationSelect
              .isVariationSelected)
        );
      }
    },

    isLoading() {
      return (
        this.$store.state.items.isAddToBasketLoading === this.variationId ||
        this.$store.state.items.isSetLoading
      );
    },

    ...mapState({
      basketItems: (state) => state.basket.items,
      isBasketLoading: (state) => state.basket.isBasketLoading,
    }),
  },

  data() {
    return {
      quantity: 1,
      buttonLockState: false,
    };
  },

  methods: {
    /**
     * add an item to basket-resource
     */
    addToBasket(goToCheckout = false) {
      if (!goToCheckout) {
        this.$store.dispatch("loadComponent", "add-item-to-basket-overlay");
        this.$store.dispatch("loadComponent", "basket-preview");
      }

      if (
        this.variationMissingProperties !== undefined &&
        this.variationMissingProperties.length
      ) {
        this.showMissingPropertiesError();
      } else if (this.isSalable || this.isSet) {
        this.$store.commit("setIsAddToBasketLoading", this.variationId);

        const orderParamsAndSurcharge = extractPropertiesAndSurcharge(
          this.orderProperties
        );

        const basketObject = {
          variationId: this.variationId,
          quantity: this.quantity,
          basketItemOrderParams: orderParamsAndSurcharge.orderParams,
          totalOrderParamsMarkup: orderParamsAndSurcharge.totalSurcharge,
        };

        if (this.isSet) {
          const setComponents = [];
          this.$store.state.items.setComponentIds.forEach((itemId) => {
            const setComponent =
              this.$store.getters[`${itemId}/currentItemVariation`];

            const variationId = setComponent && setComponent.variation.id;

            // Extract order properties and total surcharge for set components
            const setComponentOrderParamsAndSurcharge =
              extractPropertiesAndSurcharge(
                setComponent.properties.filter(
                  (prop) => prop.property.isOderProperty
                )
              );

            setComponents.push({
              variationId: variationId,
              quantity: this.$store.state.items[itemId].variationOrderQuantity,
              basketItemOrderParams:
                setComponentOrderParamsAndSurcharge.orderParams,
              totalOrderParamsMarkup:
                setComponentOrderParamsAndSurcharge.totalSurcharge,
            });
          });
          basketObject.setComponents = setComponents;
        }

        if (this.currentVariation && window.dataLayer) {
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: this.currentVariation.prices.default.currency,
              value: this.currentVariation.prices.default.isNet
                ? this.currentVariation.prices.default.data.unitPriceNet
                : this.currentVariation.prices.default.data.unitPrice,
              items: [
                {
                  item_id: this.currentVariation.variation.id,
                  item_name: this.currentVariation.texts.name3,
                  affiliation: "Google Merchandise Store",
                  coupon: "",
                  discount:
                    this.currentVariation.prices.rrp.data.unitPrice -
                    this.currentVariation.prices.default.data.unitPrice,
                  index: 0,
                  item_brand: "Morgenland",
                  price: this.currentVariation.prices.rrp.isNet
                    ? this.currentVariation.prices.rrp.data.unitPriceNet
                    : this.currentVariation.prices.rrp.data.unitPrice,
                  quantity: 1,
                },
              ],
            },
          });
        }

        this.$store.dispatch("addBasketItem", basketObject).then(
          (response) => {
            document.dispatchEvent(
              new CustomEvent("afterBasketItemAdded", { detail: basketObject })
            );
            this.$store.commit("setIsAddToBasketLoading", 0);
          },
          (error) => {
            this.$store.commit("setIsAddToBasketLoading", 0);

            if (error.data) {
              NotificationService.error(
                this.$translate(
                  "Ceres::Template." +
                    ExceptionMap.get(error.data.exceptionCode.toString()),
                  error.data.placeholder
                )
              ).closeAfter(5000);
            }
          }
        );
      }

      if (goToCheckout) {
        setTimeout(() => {
          window.location.href = "/checkout";
        }, 1000);
      }
    },
    showMissingPropertiesError() {
      this.$store.commit(`${this.itemId}/setVariationMarkInvalidProps`, true);

      const propertyNames = this.variationMissingProperties.map(
        (property) => property.property.names.name
      );
      let errorMsgContent = "";

      for (const name of propertyNames) {
        errorMsgContent += name + "<br>";
      }

      NotificationService.error(
        this.$translate(
          "Ceres::Template.singleItemMissingOrderPropertiesError"
        ).replace("<properties>", errorMsgContent)
      ).closeAfter(5000);
    },

    directToItem() {
      navigateTo(this.itemUrl);
    },

    handleButtonState(value) {
      this.buttonLockState = value;
    },

    /**
     * update the property quantity of the current instance
     * @param value
     */
    updateQuantity(value) {
      this.quantity = value;
    },
  },

  watch: {
    quantity(value) {
      if (!isNullOrUndefined(this.itemId)) {
        this.$store.commit(`${this.itemId}/setVariationOrderQuantity`, value);
        this.$store.commit(
          `${this.itemId}/setVariationPropertySurcharges`,
          this.$store.getters[`${this.itemId}/variationBasePrice`]
        );
      }
    },

    variationOrderQuantity(value) {
      if (this.quantity !== value) {
        this.quantity = value;
      }
    },

    propQuantity(value) {
      if (!isNaN(value)) {
        this.quantity = value;
      }
    },
  },
};

function extractPropertiesAndSurcharge(orderProperties) {
  let totalSurcharge = 0;
  const orderParams = [];

  orderProperties.forEach((orderProperty) => {
    if (!isNullOrUndefined(orderProperty.property.value)) {
      const property = orderProperty.property;

      if (
        property.valueType === "float" &&
        !isNullOrUndefined(property.value) &&
        property.value.slice(-1) === App.decimalSeparator
      ) {
        property.value = property.value.substr(0, property.value.length - 1);
      }

      totalSurcharge +=
        (orderProperty.surcharge || 0) + (property.surcharge || 0);

      orderParams.push({
        propertyId: property.id,
        type: property.valueType,
        name: property.names.name,
        value: property.value,
      });
    }
  });

  return {
    orderParams: orderParams,
    totalSurcharge: totalSurcharge,
  };
}
</script>
